export default "__VITE_ASSET__862e4982__"